var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.figureType === 1)?_c('v-tour',{attrs:{"name":"myTour","steps":_vm.stepsCornelsen,"options":_vm.myOptions}}):_c('v-tour',{attrs:{"name":"myTour","steps":_vm.steps,"options":_vm.myOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }